// extracted by mini-css-extract-plugin
export default {"svgContainer":"AssembleeHemicycle_svgContainer__KXkEo","legendContainer":"AssembleeHemicycle_legendContainer__2V5PD","legendItem":"AssembleeHemicycle_legendItem__DbK73"};